import { GetterTree } from 'vuex'
import { UserSession } from './types'
import { RootState } from '@/types'

export const getters: GetterTree<UserSession, RootState> = {
  authenticated(state) { return state.authenticated },
  checkTimeout(state) { return state.checkTimeout },
  user(state) { return state.user },
  currentAccesses(state) { return (state.user) ? state.user.accesses.map(access => access.to) : [] },
  session(state) { return {
    authenticated: state.authenticated,
    checkTimeout: state.checkTimeout,
    language: state.language,
    user: state.user,
    wss: state.wss
  }}
}
